import { render, staticRenderFns } from "./houseDetail.vue?vue&type=template&id=1cd179ec&scoped=true&"
import script from "./houseDetail.vue?vue&type=script&lang=js&"
export * from "./houseDetail.vue?vue&type=script&lang=js&"
import style0 from "./houseDetail.vue?vue&type=style&index=0&id=1cd179ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd179ec",
  null
  
)

export default component.exports